import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectAllocatedBudgetRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditProjectAllocatedBudgetRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditProjectAllocatedBudgetRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
